module.exports = __webpack_public_path__ + "img/sd-500.7781b04f.png";